import { css } from '@emotion/core'
import styled, { ButtonProps, Theme } from '@themes/theme'
import React from 'react'

// TODO AdvButton은 버튼 형태의 디자인에만 사용
// 텍스트 버튼 / 아이콘 버튼 / 아이콘 + 텍스트 버튼
// 이벤트가 있는 카드형태 or 기타 형태의 버튼은 @styles/button.style <Button> 사용하기
const BasicButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const {
    className,
    text = [],
    ico,
    rightIco,
    badge,
    img,
    contents,
    onClick,
  } = props

  const txt = []
  let count = 1
  for (const el of text) {
    const brTagKey = `Button:Br:${count}`
    const buttonTextKey = `Button:Txt:${count}`
    if (txt.length > 0) {
      txt.push(<br key={brTagKey}/>)
    }
    if (text) {
      txt.push(
        <span key={buttonTextKey} className="btn-txt">{el}</span>,
      )
    }
    count += 1
  }

  let btnTxt
  if (text.length > 0) {
    btnTxt = <span className="txt-wrap">{txt}</span>
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
    >
      {ico && !rightIco && <span className="btn-ico">{ico}</span>}
      {img && <img src={img} alt="이미지" className="btn-img"/>}
      {btnTxt}
      {contents && contents}
      {ico && rightIco && <span className="btn-ico">{ico}</span>}
      {badge && <span className="btn-badge">{badge}</span>}
    </button>
  )
}

export const AdvButton = styled(BasicButton)`
  z-index: ${props => {
    if (props.zIndex) return props.zIndex /* % 단위 */
    return
  }};;
  display: ${props => {
    if (props.flex) return 'inline-flex'
    return 'inline-block'
  }};
  flex-flow: ${props => {
    if (props.flex && props.column) return 'column'
    if (props.flex) return 'row'
    return
  }};
  justify-content: ${props => {
    // if (props.flex && props.spaceBetween) return 'space-between'
    if (props.flex && props.alignCenter) return 'center'
    if (props.flex) return 'flex-start'
    return
  }};
  align-items: ${props => {
    if (props.flex && props.alignCenter) return 'center'
    if (props.flex) return 'flex-start'
    return
  }};
  width: ${props => {
    if (typeof props.width === 'string') return props.width /* % 단위 */
    if (props.width) return `${props.width}px`
    return 'auto'
  }};
  min-width: ${props => {
    if (typeof props.minWidth === 'string') return props.minWidth /* % 단위 */
    if (props.minWidth) return `${props.minWidth}px`
    return
  }};
  height: ${props => {
    if (typeof props.height === 'string') return props.height /* % 단위 */
    if (props.height) return `${props.height}px`
    return 'auto'
  }};
  margin: ${props => {
    if (typeof props.margin === 'string') return props.margin /* % 단위 */
    if (props.margin) return `${props.margin}px`
    return 0
  }};
  padding: ${props => {
    if (typeof props.padding === 'string') return props.padding /* % 단위 */
    if (props.padding) return `${props.padding}px`
    return 0
  }};
  border: ${props => {
    if (props.border) return props.border
    return 0
  }};
  box-shadow: ${props => {
    if (props.boxShadow) return props.boxShadow
    return 'none'
  }};
  border-radius: ${props => {
    if (typeof props.borderRadius === 'string') return props.borderRadius /* % 단위 */
    if (props.borderRadius) return `${props.borderRadius}px`
    return 0
  }};
  ${props => {
    if (props.borderRadius && !props.badge) return 'overflow: hidden'
    return
  }};
  vertical-align: middle;
  text-align: ${props => {
    if (props.txtAlignCenter) return 'center'
    return 'left'
  }};
  color: ${props => {
    if (props.color === 'primaryBg') return props.theme.color.primaryBg
    if (props.color === 'secondaryBg') return props.theme.color.secondaryBg
    if (props.color === 'modalBlue') return props.theme.color.modalBlue
    if (props.color === 'subBg') return props.theme.color.subBg
    if (props.color === 'matchTit1') return props.theme.color.matchTit1
    if (props.color === 'subColor') return props.theme.color.subColor
    if (props.color === 'subColor2') return props.theme.color.subColor2
    if (props.color === 'btn') return props.theme.color.btn
    if (props.color === 'mainColor') return props.theme.color.mainColor
    if (props.color === 'modalSubTxt') return props.theme.color.modalSubTxt
    if (props.color === 'darkTxt') return props.theme.color.darkTxt
    if (props.color === 'disableTxt2') return props.theme.color.disableTxt2
    return props.theme.color.themeTxt
  }};
  background: ${props => {
    if (props.primary) return props.theme.color.primaryBg
    if (props.secondary) return props.theme.color.secondaryBg
    if (props.navy) return props.theme.color.modalBlue
    if (props.sub) return props.theme.color.subBg
    if (props.blue) return props.theme.color.matchTit1
    if (props.gray) return props.theme.color.subColor
    if (props.darkgray) return props.theme.color.subColor2
    if (props.btn) return props.theme.color.btn
    if (props.main) return props.theme.color.mainColor
    if (props.white) return props.theme.color.white
    return props.theme.color.TP
  }};
  cursor: pointer;

  .btn-ico {
    display: inline-block;
    width: auto;
    height: ${props => {
      if (typeof props.icoSize === 'string') return props.icoSize
      if (props.icoSize) return `${props.icoSize}px`
      return 'auto'
    }};
    transform: ${props => {
      if (props.icoRotate) return `rotate(${props.icoRotate}deg)`
      return
    }};
    color: ${props => {
      if (props.icoColor === 'primaryBg') return props.theme.color.primaryBg
      if (props.icoColor === 'secondaryBg') return props.theme.color.secondaryBg
      if (props.icoColor === 'modalBlue') return props.theme.color.modalBlue
      if (props.icoColor === 'subBg') return props.theme.color.subBg
      if (props.icoColor === 'matchTit1') return props.theme.color.matchTit1
      if (props.icoColor === 'subColor') return props.theme.color.subColor
      if (props.icoColor === 'subColor2') return props.theme.color.subColor2
      if (props.icoColor === 'btn') return props.theme.color.btn
      if (props.icoColor === 'mainColor') return props.theme.color.mainColor
      if (props.icoColor === 'modalSubTxt') return props.theme.color.modalSubTxt
      if (props.icoColor === 'white') return props.theme.color.white
      if (props.icoColor === 'darkTxt') return props.theme.color.darkTxt
      if (props.icoColor === 'disableTxt2') return props.theme.color.disableTxt2
      if (typeof props.icoColor === 'string') return props.icoColor /* theme color가 아닌 일회성 색일 경우 */
      return
    }};
    svg {
      width: auto;
      height: inherit;
      .bg {
        color: ${props => {
          if (props.icoBgColor === 'primaryBg') return props.theme.color.primaryBg
          if (props.icoBgColor === 'secondaryBg') return props.theme.color.secondaryBg
          if (props.icoBgColor === 'modalBlue') return props.theme.color.modalBlue
          if (props.icoBgColor === 'subBg') return props.theme.color.subBg
          if (props.icoBgColor === 'matchTit1') return props.theme.color.matchTit1
          if (props.icoBgColor === 'subColor') return props.theme.color.subColor
          if (props.icoBgColor === 'subColor2') return props.theme.color.subColor2
          if (props.icoBgColor === 'btn') return props.theme.color.btn
          if (props.icoBgColor === 'mainColor') return props.theme.color.mainColor
          if (props.icoBgColor === 'modalSubTxt') return props.theme.color.modalSubTxt
          return
        }};
      }
    }
  }

  .btn-img {
    width: auto;
    height: ${props => {
      if (props.icoSize) return `${props.icoSize}px`
      return 'inherit'
    }};
    // badge가 적용될 경우 btn에 overflow: hidden이 적용되면 안되기 때문에
    border-radius: ${props => {
      if (typeof props.imgBorderRadius === 'string') return props.imgBorderRadius /* % 단위 */
      if (props.imgBorderRadius) return `${props.imgBorderRadius}px`
      return
    }};
  }
  .btn-badge {
    position: absolute;
    top: ${props => {
      if (props.badgeTop) return `-${props.badgeTop}px`
      return 0
    }};
    right: ${props => {
      if (props.badgeRight) return `-${props.badgeRight}px`
      return 0
    }};
    width: auto;
    height: ${props => {
      if (props.badgeSize) return `${props.badgeSize}px`
      return 'auto'
    }};
  }

  .btn-txt {
    font-weight: ${props => {
      if (props.bold) return props.theme.fontW.bold
      return props.theme.fontW.medium
    }};
    font-size: ${props => {
      if (props.fontSize === 'large') return props.theme.font.large
      if (props.fontSize === 'small') return props.theme.font.small
      return props.theme.font.medium
    }};
    color: ${props => {
      if (props.color === 'primaryBg') return props.theme.color.primaryBg
      if (props.color === 'secondaryBg') return props.theme.color.secondaryBg
      if (props.color === 'modalBlue') return props.theme.color.modalBlue
      if (props.color === 'subBg') return props.theme.color.subBg
      if (props.color === 'matchTit1') return props.theme.color.matchTit1
      if (props.color === 'subColor') return props.theme.color.subColor
      if (props.color === 'subColor2') return props.theme.color.subColor2
      if (props.color === 'btn') return props.theme.color.btn
      if (props.color === 'mainColor') return props.theme.color.mainColor
      if (props.color === 'modalSubTxt') return props.theme.color.modalSubTxt
      if (props.color === 'modalDarkBg') return props.theme.color.modalDarkBg
      if (props.color === 'disableTxt2') return props.theme.color.disableTxt2
      return
    }};
  }
`
export const CloseBtnStyle = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  right: 0;
  padding: 9px;
  transform: translateY(-50%);

  .bg {
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: ${theme.color.gray};
  }

  &::before {
    position: absolute;
    top: 50%;
    left: 40%;
    display: block;
    width: 20%;
    height: 1px;
    background: ${theme.color.themeTxt};
    border: none;
    border-radius: 0;
    transform: rotate(45deg) scale(1.5);
    opacity: 1;
    animation: none;
    content: '';
  }

  &::after {
    position: absolute;
    top: 50%;
    left: 40%;
    display: block;
    width: 20%;
    height: 1px;
    background: ${theme.color.themeTxt};
    transform: rotate(-45deg) scale(1.5);
    opacity: 1;
    content: '';
  }

  .close-txt {
    position: absolute;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
  }
`
